$(document).ready(function(){
  $(document).on("click",'a[data-link="brand-service-centers"],a[data-link="car-services-near-me"]',function(e){
    e.preventDefault();
    var anchorLink = $(this).data('link');
    var city =  getCookie('city');
    window.location.href = "/a/en/"+city+'/'+anchorLink;
    
  })

  $(document).on("click",'.service-center a',function(e){
    e.preventDefault();
    var pageLink = $(this).attr("href");
    var parts = pageLink.split('/');
    var pageHandle = parts[parts.length - 1];
      
    var urlArray = pageHandle.split("-service-center-near-me");
    var brandName = urlArray[0];
    brandName = brandName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    var city =  getCookie('city');
    window.location.href = "/a/en/"+city+'/'+brandName+"/service-centers";
  });

  $(document).on("click",".city .services a", function(e){
      e.preventDefault();
      var pageLink = $(this).attr("href");
      var parts = pageLink.split('/');
      var pageHandle = parts[parts.length - 1];
      var urlArray = pageHandle.split("-car-service-center-near-me");
      var plcaeName = urlArray[0];
      plcaeName = plcaeName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      var city =  getCookie('city');
      window.location.href = "/a/en/"+city+'/'+plcaeName+"/car-service-centers";
  })





  
  
});